import { logger } from '../../../logger/logger'
import { v4 as uuidv4 } from 'uuid'
import { setCartPaymentTap2PayEnabled, setCartPaymentTap2PayErrorType, setCartPaymentTap2PayModalCloseRequest, setCartPaymentTap2PayPaymentErrorType } from '../../../redux/action/cartPayment'
import { setDesktopIsConnecting } from '../../../redux/action/desktop'
import { setAppNotificationData, setAppStatus } from '../../../redux/action/notifications'
import { setProvidedCredentials } from '../../../redux/action'
import { provideFreshTap2PayConnectionTokenThunk } from '../../../redux/thunk/cartPayment/tap2PayPayment'
import { toast } from 'react-toastify'
import { localStorageApi } from '../../../helper/localStorageApi'

export const messageParser = (value) => {
	try {
		return JSON.parse(value)
	} catch (e) {
		logger.warn('Message parser Error parsing message data:', e)
		return value
	}
}
export const handleKassaAppListener = (message, dispatch) => {
	const rawData = message?.data
	const isSensitiveMessage = typeof rawData === 'string' && rawData.includes('kassa-app.SAVED_CREDENTIALS_PROVIDED')
	logger.info('App listener handleKassaAppListener message:', isSensitiveMessage ? '[redacted]' : JSON.stringify(rawData))
	if (!message || !message?.data || message?.data === 'recaptcha-setup') {
		return
	}
	try {
		const messageData = messageParser(message.data)
		const messageType = messageData?.type
		if (!messageType) {
			return
		}
		const messageFromConsole = JSON.stringify(message.data)
		logger.info(`App listener Get message type:${messageType}`, isSensitiveMessage ? '[redacted]' : messageFromConsole)
		switch (messageType) {
			case 'kassa-app.TAP_TO_PAY_ENABLED':
				dispatch(setCartPaymentTap2PayEnabled(messageData?.data?.enabled))
				break
			case 'kassa-app.TAP_TO_PAY_STATUS':
				dispatch(setCartPaymentTap2PayEnabled(messageData?.data?.enabled))
				dispatch(setCartPaymentTap2PayErrorType(messageData?.data?.errorType))
				break
			case 'kassa-app.TAP_TO_PAY_PAYMENT_STATUS':
				dispatch(setCartPaymentTap2PayPaymentErrorType(messageData?.data?.errorType))
				break
			case 'kassa-app.TAP_TO_PAY_MODAL_CLOSE':
				dispatch(setCartPaymentTap2PayModalCloseRequest(messageData?.data?.close))
				break
			case 'kassa-app.ANDROID_CONNECTED_SUCCESSFULLY':
				localStorageApi.setItem('desktopClientUsername', messageData?.data?.email)
				dispatch(setDesktopIsConnecting(false))
				toast.success('Android client connection success')
				break
			case 'kassa-app.ANDROID_CONNECTION_FAILED':
				dispatch(setDesktopIsConnecting(false))
				toast.error('Failed to connect android client')
				break
			case 'kassa-app.NOTIFICATION_DATA_COLLECTED':
				logger.info(`Set notification data to redux: ${messageFromConsole}`)
				dispatch(setAppNotificationData(messageData?.data))
				break
			case 'kassa-app.APP_OPENED':
				logger.info(`App opened: ${messageFromConsole}`)
				dispatch(setAppStatus(true))
				break
			case 'kassa-app.APP_CLOSED':
				logger.info(`App closed: ${messageFromConsole}`)
				dispatch(setAppStatus(false))
				break
			case 'kassa-app.SAVED_CREDENTIALS_PROVIDED':
				dispatch(setProvidedCredentials(messageData?.data?.credentials))
				break
			case 'kassa-app.TAP_TO_PAY_CONNECTION_TOKEN_REQUESTED':
				dispatch(provideFreshTap2PayConnectionTokenThunk())
				break
			default:
				break
		}

	} catch (error) {
		logger.warn('Kassa App handler error: ' + error.message + ', message: ' + message.data)
	}
}

export const publishKassaWebListenerReadyMessage = () => {
	if (window.ReactNativeWebView) {
		const message = JSON.stringify({
			eventId: uuidv4(),
			traceId: uuidv4(),
			type: 'kassa-web.KASSA_WEB_LISTENER_READY',
			context: 'kassa-web',
			eventTime: new Date().toISOString(),
			data: {}
		})
		window.ReactNativeWebView.postMessage(message)
		logger.info('Kassa Web listener ready to receive messages')
	}
}
